<template lang="pug">
  b-modal#editBankAccountGroup(
  ref="editBankAccountGroup"
  :title="$t('ui.combine.edit_bank_account_group')"
  centered
  no-fade
  no-close-on-backdrop
  size="xl"
  :busy="loading"
  ok-only
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      div.row.mb-2
        div.col-sm-12.col-md-4.col-lg-4
          b-form-group(:label="$t('ui.group_id')" disabled).mb-0
            DebounceInput(
              size="sm"
              ref="group_id"
              required
              type="text"
              :dirty="$v.group_id.$dirty"
              :error="$v.group_id.$error"
              v-model.trim.lazy="$v.group_id.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.group_id" :name="$t('ui.group_id')")
        div.col-sm-12.col-md-4.col-lg-4
          b-form-group(:label="$t('ui.group_name')" disabled).mb-0
            DebounceInput(
              size="sm"
              ref="group_name"
              required
              type="text"
              :dirty="$v.group_name.$dirty"
              :error="$v.group_name.$error"
              v-model.trim.lazy="$v.group_name.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.group_name" :name="$t('ui.group_name')")
      div.row
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.available_bank_account')").mb-3
            div.row.mb-3.animated.fadeIn
              div.col
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th.text-center.sticky-position(width="10%")
                        span &nbsp;
                      th.sticky-position(width="20%")
                        span(:title="$t('ui.bank_name')") {{ $t("ui.bank_name") }}
                      th.sticky-position(width="30%")
                        span(:title="$t('ui.bank_acc_no')") {{ $t("ui.bank_acc_no") }}
                      th.sticky-position(width="40%")
                        span(:title="$t('ui.bank_acc_holder')") {{ $t("ui.bank_acc_holder") }}
                  tbody.clusterize-content
                    tr(v-for="(item, index) in filterFreeList")
                      td.actions.text-center
                        span
                          a.fa.fa-plus.text-success(href="#" @click="onAdd(item)" :ttile="$t('ui.add')")
                      td
                        span(:title="item.bank_name + ' (' + item.bank_id + ')'") {{ item.bank_name }}
                      td
                        span(:title="item.bank_acc_no") {{ item.bank_acc_no }}
                      td
                        span(:title="item.bank_acc_holder") {{ item.bank_acc_holder }}
        div.col-sm-12.col-md-6.col-lg-6
          b-form-group(:label="$t('ui.group_bank_account')").mb-3
            div.row.mb-3.animated.fadeIn
              div.col
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th.text-center.sticky-position(width="10%")
                        span &nbsp;
                      th.sticky-position(width="20%")
                        span(:title="$t('ui.bank_name')") {{ $t("ui.bank_name") }}
                      th.sticky-position(width="30%")
                        span(:title="$t('ui.bank_acc_no')") {{ $t("ui.bank_acc_no") }}
                      th.sticky-position(width="40%")
                        span(:title="$t('ui.bank_acc_holder')") {{ $t("ui.bank_acc_holder") }}
                  tbody.clusterize-content
                    tr(v-for="(item, index) in bankAccountGroupList")
                      td.actions.text-center
                        span
                          a.fa.fa-trash.text-danger(href="#" @click="onRemove(item)" :ttile="$t('ui.remove')")
                      td
                        span(:title="item.bank_name + ' (' + item.bank_id + ')'") {{ item.bank_name }}
                      td
                        span(:title="item.bank_acc_no") {{ item.bank_acc_no }}
                      td
                        span(:title="item.bank_acc_holder") {{ item.bank_acc_holder }}
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, minValue, maxValue } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      bankAccountGroupList: [],
      bankDepositList: [],
      group_id: '',
      group_name: '',
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    filterFreeList() {
      var freeList = this.bankDepositList;
      var groupList = this.bankAccountGroupList;
      var list = [];

      for(var i = 0; i < freeList.length; i++) {
        var temp = groupList.filter(item => { return item.bank_id == freeList[i].bank_id && item.bank_acc_no == freeList[i].bank_acc_no });
        if (temp.length == 0) {
          list.push(freeList[i]);
        }
      }

      return list;
    }
  },
  validations: {
    group_id: {
      required,
      alphaNum
    },
    group_name: {
      required,
      alphaNum
    },
  },
  methods: {
    onAdd: function(e) {
      let url = config.bankAccountGroupAddUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        group_id: this.item.group_id,
        bank_id: e.bank_id,
        bank_acc_no: e.bank_acc_no,
        audit_by: this.$store.getters.loginId,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getBankAccountGroupList();
                this.getBankDepositList();
                // this.addBankAccountGroup(e.RTFCommentaryID, e.RTFCommentaryName, e.RTFCommentaryDescription);
                // this.$helpers.showDialog(this.$t("ui.combine.change_bank_group"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                //this.$emit("failed", "update_profile", this.feedback.status);
                // this.$refs.updateMemberProfile.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    onRemove: function(e) {
      let url = config.bankAccountGroupRemoveUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        group_id: this.item.group_id,
        bank_id: e.bank_id,
        bank_acc_no: e.bank_acc_no,
        audit_by: this.$store.getters.loginId,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getBankAccountGroupList();
                this.getBankDepositList();
                // this.addBankAccountGroup(e.RTFCommentaryID, e.RTFCommentaryName, e.RTFCommentaryDescription);
                // this.$helpers.showDialog(this.$t("ui.combine.change_bank_group"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                //this.$emit("failed", "update_profile", this.feedback.status);
                // this.$refs.updateMemberProfile.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    getBankAccountGroupList: function() {
      let url = config.bankAccountGroupListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        group_id: this.item.group_id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.bankAccountGroupList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getBankDepositList: function() {
      let url = config.bankListDepositUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.bankDepositList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.group_id = this.item.group_id;
      this.group_name = this.item.group_name;
      this.getBankDepositList();
      this.getBankAccountGroupList();
    }
  }
};
</script>
